import {
  PaymentProviderGroupDto,
  PSPGroupTypes,
} from 'api/PaymentProvider/Types/PaymentProviderGroupDto'

export const normalizePaymentProviders = (
  paymentProviders: PaymentProviderGroupDto[],
  uncovered?: boolean
): PaymentProviderGroupDto[] => {
  return paymentProviders.filter(
    (item) =>
      item.pspGroupType.id === (uncovered ? PSPGroupTypes.Uncovered : PSPGroupTypes.DepositWithdraw)
  )
}
